import React from "react";
import Card from "components/card";
import { MdArrowBack } from "react-icons/md";

interface ErrorScreenProps {
  error: string;
  onBack: () => void;
}

export const LoadingScreen: React.FC = () => {
  return (
    <div className="flex h-full items-center justify-center p-4">
      <div className="flex flex-col items-center">
        <div className="h-10 w-10 animate-spin rounded-full border-4 border-gray-200 border-t-blue-500"></div>
        <p className="mt-4 text-lg font-medium text-gray-700">Cargando resultados...</p>
      </div>
    </div>
  );
};

export const ErrorScreen: React.FC<ErrorScreenProps> = ({ error, onBack }) => {
  return (
    <div className="flex h-full items-center justify-center p-4">
      <Card extra="w-full max-w-4xl p-6">
        <div className="flex flex-col items-center">
          <div className="rounded-full bg-red-100 p-4">
            <svg className="h-10 w-10 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </div>
          <h2 className="mt-4 text-xl font-bold text-navy-700 dark:text-white">Error</h2>
          <p className="mt-2 text-center text-gray-600">{error || "No se pudieron cargar los resultados del cuestionario"}</p>
          <button
            onClick={onBack}
            className="mt-6 flex items-center gap-2 rounded-lg bg-brand-500 px-4 py-2 text-white hover:bg-brand-600"
          >
            <MdArrowBack />
            <span>Volver</span>
          </button>
        </div>
      </Card>
    </div>
  );
}; 